import { combineEpics, ofType } from "redux-observable";
import { map, withLatestFrom } from "rxjs";
import { RootState } from "../store/ConfigureStore";
import * as summaryActions from "../store/dashboard/SummarySlice";



const setTotalSystemTdh = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasHandlerCalculation/setGKXCalculationData",
            "gasHandlerCalculation/setCP1CalculationData",
            "gasHandlerCalculation/setCP2CalculationData",
            "gasHandlerCalculation/setCP3CalculationData",
            "pump/setPumpInputCalculated",
            "pump/setPumpFinalTDH",
            "gasHandlerCalculation/setCP1FinalTDH",
            "gasHandlerCalculation/setCP2FinalTDH",
            "gasHandlerCalculation/setCP3FinalTDH"
        ),
        withLatestFrom(            
            state$.pipe(map((state: RootState) => state?.pump?.PumpInputCalculated)),
            state$.pipe(map((state: RootState) => state?.gasHandler?.GKXCalculationData)),
            state$.pipe(map((state: RootState) => state?.gasHandler?.CP1CalculationData)),
            state$.pipe(map((state: RootState) => state?.gasHandler?.CP2CalculationData)),
            state$.pipe(map((state: RootState) => state?.gasHandler?.CP3CalculationData))
        ),
        map(([actionData, mainPumpData, gkxData, cp1Data, cp2Data, cp3Data]) => {
            const pumpTDH = isNaN(+mainPumpData?.pmpFinalTDH) ? 0 : +mainPumpData?.pmpFinalTDH;
            const gkxTDH = isNaN(+gkxData?.finalTDH) ? 0 : +gkxData?.finalTDH;
            const cp1TDH = isNaN(+cp1Data?.finalTDH) ? 0 : +cp1Data?.finalTDH;
            const cp2TDH = isNaN(+cp2Data?.finalTDH) ? 0 : +cp2Data?.finalTDH;
            const cp3TDH = isNaN(+cp3Data?.finalTDH) ? 0 : +cp3Data?.finalTDH;
            const systemLiftTdh = (pumpTDH + gkxTDH + cp1TDH + cp2TDH + cp3TDH).toFixed(2);
            
            return summaryActions.SetTotalSystemTDH(systemLiftTdh)
        })
    );
}

export const summaryEpic = combineEpics(
    setTotalSystemTdh
);





